import * as antd from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';
import enGBlocale from 'antd/lib/locale/en_GB';
import { generateDayjsConfig } from './helpers/generateDayjsConfig';
import * as components from './components';
import * as constants from './constants';
import * as services from './services';
import * as types from './types';
var antdHelpers = { generatePicker: generatePicker, generateDayjsConfig: generateDayjsConfig, enGBlocale: enGBlocale };
export { antd, antdHelpers, constants, components, services, types };
//# sourceMappingURL=index.js.map